import React from 'react';
import gif from "./nonce.gif";

const MiningConcept = (props) => {
  return (
    <div>
      <p className="step-p"> The process of determining this nonce is called mining.</p>

      <p>
        We start with a nonce of 0 and keep incrementing it by 1 until we find a valid hash.
      </p>

      <img
        src={gif}
        style={{ marginTop: "20px", marginBottom: "10px", height: "100%", width: "100%", overflow: "hidden" }}
        alt="nonce.gif"
      />

      <p className="step-p">
        As difficulty <b>increases</b>, the number of possible valid hashes <b>decreases</b>.
        With fewer possible valid hashes, it takes more processing power to find a valid
        hash.
      </p>

      <p className="step-p"> If the hash on the block is invalid, click on the tool button to mine the genesis block! </p>
    </div>
  );
};

export default MiningConcept;


// WEBPACK FOOTER //
// ./src/steps/mining/mining-concept.js